const handleize = (text) => {
  text = text.toLowerCase();
  text = text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  text = text.replace(/[^a-z0-9]+/g, "-");
  text = text.replace(/^-+|-+$/g, "");
  return text;
};

class ShopifySwiper {
  constructor(sectionId, slidesPerView, slidesPerViewResponsive, spaceBetween) {
    this.sectionId = sectionId;
    this.slidesPerView = slidesPerView;
    this.slidesPerViewResponsive = slidesPerViewResponsive;
    this.spaceBetween = spaceBetween || 20;

    document.addEventListener("DOMContentLoaded", () => {
      this.initSwiper();
    });
  }

  parseSlidesPerView(value) {
    return value === "auto" ? "auto" : value;
  }

  initSwiper() {
    new Swiper(`#shopify-section-${this.sectionId} .swiper`, {
      direction: "horizontal",
      breakpoints: {
        690: {
          slidesPerView: this.slidesPerViewResponsive,
          spaceBetween: this.spaceBetween,
        },
        968: {
          slidesPerView: this.parseSlidesPerView(this.slidesPerView),
          spaceBetween: this.spaceBetween,
        },
      },
      navigation: {
        nextEl: `#shopify-section-${this.sectionId} .swiper-button-next`,
        prevEl: `#shopify-section-${this.sectionId} .swiper-button-prev`,
      },
      scrollbar: {
        el: `#shopify-section-${this.sectionId} .swiper-scrollbar`,
      },
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const buttons_menu_responsive = document.querySelectorAll(
    ".button-open-collapse"
  );
  buttons_menu_responsive.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      const isExpanded = button.getAttribute("aria-expanded") === "true";
      button.setAttribute("aria-expanded", !isExpanded);
    });
  });

  const buttons_first_reset = document.querySelectorAll("li.first-option");
  buttons_first_reset.forEach((button) => {
    button.addEventListener("click", (event) => {
      button.parentElement
        .querySelectorAll(".button-open-collapse")
        .forEach((button) => {
          button.setAttribute("aria-expanded", false);
        });
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const responsive_active = window.matchMedia("(max-width: 690px)");

  if (responsive_active.matches) {
    document.querySelectorAll(".navigation-promo.swiper").forEach((swiper) => {
      new Swiper(swiper, {
        direction: "horizontal",
        breakpoints: {
          690: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          968: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
        },
      });
    });
  }
});

// ─── Product Add-ons (Monogram / Alteration / Engraving) ─────────────────────
const _hasAddons = document.querySelector(
  "monogram-component, checkbox-options, modal-alterations, [data-open-edit-modal]"
);

if (_hasAddons) {
  import("{{ 'product-addons.module.js' | asset_url }}")
    .then(({ openEditModalCart, resetModalDrawerCart }) => {
      window.__addons = { openEditModalCart, resetModalDrawerCart };
    })
    .catch((err) => console.error("Failed to load product-addons module:", err));
}

// MODAL COMPONENT
class ModalComponent extends HTMLElement {
  constructor() {
    super();
    this.close = this.close.bind(this);
  }

  connectedCallback() {
    this.title = this.getAttribute("title") || "Default Title";
    this.render();

    const id = this.getAttribute("id");

    if (!id) return console.error("Modal component must have an id attribute");

    document.addEventListener("DOMContentLoaded", () => {
      const buttonClose = document
        .querySelector(`#${id}`)
        .querySelector(".close-button");
      const overlay = document
        .querySelector(`#${id}`)
        .querySelector(".overlay");
      if (buttonClose) {
        buttonClose.addEventListener("click", this.close);
      }

      if (overlay) {
        overlay.addEventListener("click", this.close);
      }
    });
  }

  disconnectedCallback() {
    this.querySelector(".close-button").removeEventListener(
      "click",
      this.close
    );
  }

  open() {
    this.querySelector(".modal").style.display = "flex";
  }

  close() {
    this.querySelector(".modal").style.display = "none";
  }

  toggleState() {
    this.querySelector(".modal").style.display =
      this.querySelector(".modal").style.display === "flex" ? "none" : "flex";
  }

  render() {}
}

customElements.define("modal-component", ModalComponent);



document.addEventListener("DOMContentLoaded", () => {
  const buttonFit = document.querySelector("#button-modal-fit");
  const buttonSize = document.querySelector("#button-modal-size");
  const modalFit = document.querySelector("#modal-fit");
  const modalSize = document.querySelector("#modal-size");

  const modals = [
    {
      button: buttonFit,
      modal: modalFit,
    },
    {
      button: buttonSize,
      modal: modalSize,
    },
  ];

  modals.forEach(({ button, modal }) => {
    if (button && modal) {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        if (typeof modal.toggleState === "function") {
          modal.toggleState();
        } else {
          console.error(
            `toggleState method not found on modal with id ${modal.id}`
          );
        }
      });
    }
  });
});

function agregarEventoScroll() {
  const yotpoStars = document.querySelector(
    ".yotpo-bottomline.pull-left.star-clickable"
  );
  const yotpoReviewsWidget = document.querySelector(
    '[data-yotpo-instance-id="421150"]'
  );

  if (yotpoStars && yotpoReviewsWidget) {
    yotpoStars.addEventListener("click", function () {
      const rect = yotpoReviewsWidget.getBoundingClientRect();
      const posY = rect.top + window.pageYOffset;

      window.scrollTo({
        top: posY,
        behavior: "smooth",
      });
    });
    clearInterval(intervalId);
  }
}

const intervalId = setInterval(agregarEventoScroll, 1000);


class BreadcrumbsCollection {
  constructor(menuSelector, breadcrumbSelector) {
    this.menuSelector = menuSelector;
    this.breadcrumbSelector = breadcrumbSelector;
  }

  updateBreadcrumbs(searchText) {
    const menuItems = document.querySelectorAll(
      `.mega-menu .subnivel-child span`
    );
    let found = false;

    menuItems.forEach((span) => {
      if (found) return;

      const spanText = span.textContent.trim();
      if (spanText === searchText && !spanText.toLowerCase().includes("all")) {
        const linkElement = span.closest(".next-level")?.querySelector("a.h5");
        if (linkElement) {
          const breadcrumbItem = document.querySelector(
            this.breadcrumbSelector
          );
          const breadcrumbLink = breadcrumbItem.querySelector("a");

          breadcrumbLink.href = linkElement.href;
          breadcrumbLink.textContent = linkElement.textContent.trim();
          breadcrumbItem.style.display = "flex";

          found = true;
        }
      }
    });
  }
}

class FitGuideTabs {
  constructor() {
    this.PRIMARY_TABS = document.querySelectorAll(".header-buttons .btn");
    this.SECONDARY_TABS = document.querySelectorAll(
      ".group-content-buttons .btn"
    );

    this.CHILD_TABS = document.querySelectorAll(
      ".group-single-tabs-links .btn"
    );

    this.assignEvents();
  }

  assignEvents() {
    this.PRIMARY_TABS.forEach((tab) => {
      tab.addEventListener("click", (e) => this.handlePrimaryTabClick(e));
    });

    this.SECONDARY_TABS.forEach((tab) => {
      tab.addEventListener("click", (e) => this.handleSecOndaryTabClick(e));
    });

    this.CHILD_TABS.forEach((tab) => {
      tab.addEventListener("click", (e) => this.handleChildTabClick(e));
    });
  }

  activateFirstTab(index, tab) {
    const parent = tab.parentElement.parentElement.querySelector(
      `.tabs-content-single[index="${index}"]`
    );

    const allSecondaryTabs = parent.querySelectorAll(
      ".group-content-buttons .btn"
    );
    const allSecondaryTabContents = parent.querySelectorAll(
      ".group-content-info .single-content"
    );

    allSecondaryTabs.forEach((tab) => tab.classList.remove("active"));
    allSecondaryTabContents.forEach((content) =>
      content.classList.remove("active")
    );

    if (allSecondaryTabs.length > 0) {
      allSecondaryTabs[0].classList.add("active");
    }
    if (allSecondaryTabContents.length > 0) {
      allSecondaryTabContents[0].classList.add("active");
    }

    const allChildTabs = parent.querySelectorAll(
      ".group-single-tabs-links .btn"
    );
    const allChildTabContents = parent.querySelectorAll(".single-tab-content");

    allChildTabs.forEach((tab) => tab.classList.remove("active"));
    allChildTabContents.forEach((content) =>
      content.classList.remove("active")
    );

    if (allChildTabs.length > 0) {
      allChildTabs[0].classList.add("active");
    }
    if (allChildTabContents.length > 0) {
      allChildTabContents[0].classList.add("active");
    }
  }

  handlePrimaryTabClick(event) {
    const tab = event.target;
    const tabId = tab.getAttribute("index");
    const tabsContent = document.querySelectorAll(".tabs-content-single");
    const tabContent = document.querySelector(
      `.tabs-content-single[index="${tabId}"]`
    );

    tabsContent.forEach((tab) => tab.classList.remove("active"));
    this.PRIMARY_TABS.forEach((tab) => tab.classList.remove("active"));

    tab.classList.add("active");
    tabContent.classList.add("active");

    this.activateFirstTab(tabId, tab);
  }

  handleSecOndaryTabClick(event) {
    const tab = event.target;
    const tabId = tab.getAttribute("index");
    const parent = tab.parentElement.parentElement;
    const tabsContent = parent.querySelectorAll(
      ".group-content-info .single-content"
    );
    const tabContent = parent.querySelector(
      `.group-content-info .single-content[index="${tabId}"]`
    );

    this.SECONDARY_TABS.forEach((tab) => tab.classList.remove("active"));
    tabsContent.forEach((tab) => tab.classList.remove("active"));
    tab.classList.add("active");
    tabContent.classList.add("active");

    const parentTab = tab.parentElement.parentElement.parentElement;
    const tabsContentChild = parentTab.querySelectorAll(
      `.single-content[index="${tabId}"] .single-tab-content`
    );
    tabsContentChild.forEach((tab) => tab.classList.remove("active"));
    tabsContentChild[0].classList.add("active");

    // Ensure first child tab is activated
    const childTabs = parentTab.querySelectorAll(
      `.single-content[index="${tabId}"] .group-single-tabs-links .btn`
    );
    childTabs.forEach((tab) => tab.classList.remove("active"));
    if (childTabs.length > 0) {
      childTabs[0].classList.add("active");
    }
  }

  handleChildTabClick(event) {
    const tab = event.target;
    const tabId = tab.getAttribute("subindex");

    const parent = tab.parentElement.parentElement;
    const tabsContent = parent.querySelectorAll(`.single-tab-content`);
    const tabContent = parent.querySelector(
      `.single-tab-content[subindex="${tabId}"]`
    );

    this.CHILD_TABS.forEach((tab) => tab.classList.remove("active"));
    tabsContent.forEach((tab) => tab.classList.remove("active"));

    tabContent.classList.add("active");
    tab.classList.add("active");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new FitGuideTabs();
});

//
class ProductOptions {
  constructor() {
    const optionsColor = document.querySelector("#optionsJson").textContent;
    const optionsProduct = document.querySelector(
      "#optionsJsonProduct"
    ).textContent;

    this.options = JSON.parse(optionsColor);
    this.productSettings = JSON.parse(optionsProduct);

    this.activeSettingColor =
      this.options[0].value == "Undefined" && this.options[0].image == "";

    this.dinamicSelects = {
      formId: document.querySelector('input[name="id"]'),
      currentColor: document.querySelector("#currentColor"),
      image: document.querySelector(
        ".product-gallery__media.snap-center.is-selected"
      ),
      price: document.querySelector(".product-price"),
      buttonSubmit: document.querySelector("buy-buttons.buy-buttons>button"),
      select: document.querySelector(".variant-picker__content-dropdown"),
      checkboxes: document.querySelectorAll(
        ".variant-picker__option-values[data-option-selector]"
      ),
      variantValue: document.querySelector("variant-option-value"),
    };

    this.currentVariant = {};

    this.selects = document.querySelectorAll(".color-swatch-option input");

    this.selects.forEach((select) => {
      select.addEventListener("change", (e) => this.colorChange(e));
    });

    this.assignOrFindVariant();
  }

  assignOrFindVariant() {
    const url = new URL(window.location.href);
    const variantId = url.searchParams.get("variant_id");

    const variant = this.options.find((option) =>
      option.product[0].variants.find((variant) => variant.id == variantId)
    );

    this.assignVariant(variant);
  }

  assignVariant(variant) {
    const formatOrSetVariant = variant ?? this.options[0];
    const { product, productWithOption, value } = formatOrSetVariant;

    this.currentVariant = { name: value, variant };
    this.useChangeDataProduct({
      product: product[0],
      value,
      productWithOption,
    });

    this.handleVariantChange({
      maxOptions: productWithOption.length,
      value,
    });
  }

  selectedOption(targetValue) {
    return this.options.find((option) => option.value == targetValue);
  }

  colorChange(e) {
    e.preventDefault();
    const value = e.target.value;
    const { product, productWithOption } = this.selectedOption(value);

    this.currentVariant = { ...this.currentVariant, name: value };
    this.useChangeDataProduct({
      product: product[0],
      value,
      productWithOption,
    });
  }

  handleSelectChange(e) {
    e.preventDefault();
    const value = e.target.value;
    const { product, productWithOption } = this.selectedOption(value);

    this.currentVariant = { ...this.currentVariant, name: value };
    this.useChangeDataProduct({
      product: product[0],
      value,
      productWithOption,
    });
  }

  assignEventToSelects(value, productWithOption) {
    document
      .querySelectorAll(".variant-picker__content-dropdown")
      .forEach((parent) => {
        const select = parent.querySelector("select");
        if (!select) return;

        const newSelect = select.cloneNode(true);
        parent.replaceChild(newSelect, select);

        newSelect.addEventListener("change", () =>
          this.handleVariantChange({
            maxOptions: productWithOption.length,
            value,
          })
        );
      });
  }

  updateLegends(options, enableFirstOptionColor = false) {
    options?.forEach((option, index) => {
      const _index = enableFirstOptionColor ? index + 1 : index;
      const container = document.querySelector(`div[option="${_index}"]`);
      if (!container) return;

      container.querySelector("variant-option-value").innerHTML = `${option}`;
      container.querySelector("variant-option-value").setAttribute('aria-expanded', "option");
    });
  }

  useChangeDataProduct({ product, value, productWithOption }) {
    const { currentColor, image, formId } = this.dinamicSelects;
    currentColor.textContent = value;
    image.innerHTML = `<img src="${product.featured_image}" loading="lazy" width="100%" alt="Product image">`;

    productWithOption?.forEach((option) => {
      if (option.name === "Color" && !this.activeSettingColor) return;

      if (option.name === "Color" && value === "Undefined") {
        const container = document.querySelector(
          `.variant-picker__label-content--color .color-swatch-options`
        );
        container.innerHTML = this.generateOptionHtml("radio", option);
        container.querySelectorAll("label").forEach((label) => {
          label.addEventListener("change", (e) => this.colorChange(e));
        });
      } else {
        const typeSelects = {
          Fit: "checkbox",
        };
        const type = typeSelects[option.name] || "select";
        const container = document.querySelector(
          `.variant-picker__${option.name.toLowerCase().replace(" ", "-")}`
        );
        const content =
          type === "select"
            ? container.querySelector(`select`)
            : container.querySelector(`.variant-picker__option-values`);
        content.innerHTML = this.generateOptionHtml(type, option);

        if (type !== "select") {
          content.querySelectorAll("label").forEach((label) => {
            label.addEventListener("change", () =>
              this.handleVariantChange({
                maxOptions: productWithOption.length,
                value,
              })
            );
          });
        }
      }
    });

    this.assignEventToSelects(value, productWithOption);

    formId.value = product.variants[0].id;
  }

  generateOptionHtml(type, option) {
    return option.values
      .map((value, index) => {
        return type === "select"
          ? `<option value="${value}">${value}</option>`
          : `<input type="radio" ${
              index === 0 ? "checked" : ""
            } id="option-value-template--${value}" name="option${
              option.position
            }" value="${value}"><label class="block-swatch" for="option-value-template--${value}" data-option-value="${value}"><span>${value}</span></label>`;
      })
      .join("");
  }

  arraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }
    return arr1.every((value, index) => value === arr2[index]);
  }

  handleVariantChange({ maxOptions = 3, value }) {
    let options = {};
    const existOptionColor = this.productSettings.options.some(
      (option) => option.name === "Color"
    );

    for (let i = 1; i <= maxOptions; i++) {
      const optionName = `option${i}`;
      const optionInputs = document.querySelectorAll(`[name="${optionName}"]`);

      if (optionInputs.length === 0) continue;

      const optionValue = Array.from(optionInputs).find(
        (input) =>
          (input.type === "radio" && input.checked) ||
          input.tagName === "SELECT" ||
          input.type !== "radio"
      )?.value;

      if (optionValue !== undefined) {
        options[optionName] = optionValue;
      }
    }

    const { name } = this.currentVariant;
    const selectedOption = this.selectedOption(name);

    if (!selectedOption) return;

    const optionColorActive = !this.activeSettingColor && existOptionColor;
    const firstOption = optionColorActive ? value : options.option1;
    const optionsArray = Object.values(options).filter(
      (option) => option !== firstOption
    );

    options = [firstOption, ...optionsArray];

    const variant = selectedOption.product[0].variants.find((variant) =>
      this.arraysEqual(variant.options, options)
    );

    if (!variant) return;

    this.currentVariant = { name, variant };
    this.dinamicSelects.formId.value = variant.id;

    if (!variant.available) {
      this.dinamicSelects.buttonSubmit.disabled = true;
      this.dinamicSelects.buttonSubmit.querySelector("div").innerHTML =
        "Sold Out";
    } else {
      this.dinamicSelects.buttonSubmit.disabled = false;
      this.dinamicSelects.buttonSubmit.querySelector("div").innerHTML =
        "Add to Bag";
    }

    this.generateBackOrder();

    this.updateLegends(options, !optionColorActive);

    this.updateVariantUrl(variant.id);
  }

  updateVariantUrl(variantId) {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    params.set("variant_id", variantId);
    window.history.replaceState({}, "", url.toString());
  }

  generateBackOrder() {
    const { variant } = this.currentVariant;

    const { backorder } = variant.metafields;

    const existBackorder = document.querySelector(".backorder-container");
    if (existBackorder) existBackorder.remove();

    if (!backorder || backorder == "available" || variant.available) {
      document.querySelector('.product-info__buy-buttons .atc-wl-container button[type="submit"] div').innerText = "Add To Bag"
      return
    }

    document.querySelector('.product-info__buy-buttons .atc-wl-container button[type="submit"] div').innerText = "Preorder"

    const container = document.querySelector(
      `.product-info__buy-buttons form input[name="id"]`
    );
    const htmlBackorder = document.createElement("div");
    htmlBackorder.classList.add("backorder-container");
    htmlBackorder.innerHTML = `
    <div>
      <h3>READY TO PREORDER</h3>
      <span>This item will ship around ${backorder}. Preorder now to get it first.</span>
      <input type="hidden" name="properties[preorder]" value="This item will ship around ${backorder}. Preorder now to get it first.">
    </div>`;

    container.insertAdjacentElement("afterend", htmlBackorder);

    this.dinamicSelects.buttonSubmit.disabled = false;
    this.dinamicSelects.buttonSubmit.querySelector("div").innerHTML =
      "Available for Preorder";
  }
}

class SwatchesGrouped {
  constructor({ id, product, event, drawer_id, value }) {
    this.product = product;
    this.parent = event.target.closest(".product-card");
    this.cardContainer = this.parent.querySelector(`#${id}`);
    this.imageContainer = this.parent.querySelector(".product-card__figure");
    this.url = this.parent.querySelector(".product-card__figure a");
    this.titleUrl = this.parent.querySelector(".product-card__title a");

    const { title, featured_image, second_image, url, variant_id, price } =
      this.product;
    const formatUrl = `${url}?variant_id=${variant_id}`;

    this.updateImages(this.product);
    this.updateTitle(title);
    this.updatePrice(price);
    this.updateUrl(formatUrl);
    this.updateDrawerId(drawer_id);
    this.setCurrentSwatch(value);
  }

  setCurrentSwatch(value) {
    const swatches = this.parent.querySelectorAll(".color-swatch-option a");
    console.log("SWATCHES:", swatches)

    swatches.forEach((swatch) => {
      swatch.classList.remove("active");

      if (swatch.getAttribute("data-value") == value) {
        swatch.classList.add("active");
      }
    });

    swatches && swatches.classList.add("active");
  }

  assignEventToSwatchers() {
    const swatches = this.cardContainer.querySelectorAll(
      ".color-swatch-option a"
    );
    swatches?.forEach((swatch) => {
      swatch.addEventListener("click", (e) => {
        e.preventDefault();
        this.handleSwatchChange({
          value: e.target.getAttribute("reference"),
        });
      });
    });
  }

  updateImages(product) {
    const { title, featured_image, second_image } = product;
    const anchor = this.imageContainer.querySelector("a");
    if (featured_image || second_image) {
      const img = this.imageContainer.querySelectorAll("img");
      if (img) img.forEach((img) => img.remove());
    }

    if (featured_image && anchor) {
      anchor.innerHTML =
        anchor.innerHTML +
        `<img class="img product-card__image"  src="${featured_image}" loading="lazy" alt="${title}">`;
    }

    if (second_image && anchor) {
      anchor.innerHTML =
        anchor.innerHTML +
        `<img class="img product-card__image product-card__image--secondary" src="${second_image}" loading="lazy" alt="${title}">`;
    }
  }

  updateTitle(title) {
    const titleElement = this.parent.querySelector(".product-card__title a");
    titleElement.innerHTML = title;
  }

  updatePrice(price) {
    const priceElement = this.parent.querySelector("sale-price");
    priceElement.innerHTML = price;
  }

  updateUrl(url) {
    const urlElement = this.parent.querySelector(".product-card__figure a");
    const urlTitle = this.parent.querySelector(".product-card__title a");
    urlElement.href = url;
    urlTitle.href = url;
  }

  updateDrawerId(drawer_id) {
    const { handle } = this.product;
    const quickView = this.parent.querySelector(".quick-view");
    quickView.setAttribute("aria-controls", drawer_id);
    quickView.setAttribute("data-handle", handle);
  }

  handleSwatchChange({ value }) {
    const { product, drawer_id } = this.options.find(
      (option) => option.value == value
    );
    const { title, featured_image, second_image, url, variant_id, price } =
      product[0];
    const formatUrl = `${url}?variant_id=${variant_id}`;

    this.updateImages(product[0]);
    this.updateTitle(title);
    this.updatePrice(price);
    this.updateUrl(formatUrl);
    // this.updateDrawerId(drawer_id)
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".add_product_by_id");
  buttons.forEach((button) => {
    button.addEventListener("click", function () {
      const productId = button.getAttribute("product-id");
      !!productId && addToCart({ productId });
    });
  });
});

const isEmptyObject = (obj) => {
  return Object.keys(obj).length === 0;
};

class BackorderProduct {
  constructor(id) {
    this.variant_id = id;

    this.dinamicSelects = {
      buttonSubmit: document.querySelector("buy-buttons.buy-buttons>button"),
    };

    const variantsSelector = document.querySelector("#custom-json-product");
    if (!variantsSelector) return;

    const variants = variantsSelector?.textContent;
    this.variants = JSON.parse(variants);
    this.backorder = document.querySelector(".backorder-container");

    this.showOrDestroyBackorder()
    // this.backorder ? this.removeBackorderHTML() : this.showOrDestroyBackorder();
  }

  removeBackorderHTML() {
    const existBackorder = document.querySelector(".backorder-container");
    if (existBackorder) existBackorder.remove();
  }

  showOrDestroyBackorder() {
    const variant = this.variants.variantsMefields.find(
      (variant) => variant.id == this.variant_id
    );
    
    if (!variant) return;

    const { backorder } = variant.metafields;

    if (backorder && backorder !== "available") {

      this.removeBackorderHTML()
      this.createBackorder(backorder, variant);
    } else {
      this.removeBackorderHTML()
    }
  }

  createBackorder(backorder, variant) {
    const { available, inventory_quantity, inventory_policy, price } = variant;

    if (!available) {
      document.querySelector('.product-info__buy-buttons .atc-wl-container button[type="submit"] div').innerText = "Add To Bag"
      return
    }

    document.querySelector('.product-info__buy-buttons .atc-wl-container button[type="submit"] div').innerText = "Preorder"

    const container = document.querySelector(
      `.product-info__buy-buttons form input[name="id"]`
    );
    const htmlBackorder = document.createElement("div");
    htmlBackorder.classList.add("backorder-container");
    htmlBackorder.innerHTML = `
    <div>
      <h3>READY TO PREORDER</h3>
      <span>This item will ship around ${backorder}. Preorder now to get it first.</span>
      <input type="hidden" name="properties[preorder]" value="This item will ship around ${backorder}. Preorder now to get it first.">
    </div>`;

    container.insertAdjacentElement("afterend", htmlBackorder);

    if (inventory_policy == "deny" && inventory_quantity == 0) {
      this.dinamicSelects.buttonSubmit.disabled = true;
      this.dinamicSelects.buttonSubmit.querySelector("div").innerHTML =
        "Sold Out";
    } else if (inventory_policy == "continue") {
      this.dinamicSelects.buttonSubmit.disabled = false;
      this.dinamicSelects.buttonSubmit.querySelector(
        "div"
      ).innerHTML = `Available for Backorder`;
    }
  }
}

class LineQuantity {
  constructor() {
    this.lineItems = document.querySelectorAll("line-item-quantity");
    this.assignEvents();
  }

  assignEvents() {
    this.lineItems.forEach((lineItem) => {
      const buttons = lineItem.querySelectorAll("button");

      buttons.forEach((button) => {
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);

        newButton.addEventListener("click", (e) => {
          this.handleLineItemChange(e);
          LTKGetCart();
        });
      });
    });
  }

  handleLineItemChange(e) {
    e.preventDefault();
    const target = e.target;

    const button = target.closest("button");
    const type = button.classList.contains("decrease")
      ? "decrease"
      : "increase";

    const input = button.parentElement.querySelector("input");

    const value = parseInt(input.value);
    const newValue = type === "decrease" ? value - 1 : value + 1;

    if (!newValue) return;
    input.value = newValue;

    const event = new Event("change", { bubbles: true });
    input.dispatchEvent(event);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const lineQuantity = new LineQuantity();
});

const handleLearnMoreClick = (button) => {
  const parentElement = button.closest(
    ".product-grouping__learn_more"
  ).parentNode;
  const colorSwatchOption = parentElement.querySelectorAll(
    ".color-swatch-option"
  );

  colorSwatchOption.forEach((option) => {
    option.classList.remove("hidden");
    option.classList.remove("hidden-sm");
  });

  button.closest(".product-grouping__learn_more").classList.add("hidden");
};

const submitCartDataListrak = (cart) => {
  const cartItems = cart.items;
  let cartLink = {};

  if (cartItems.length > 0) {
    cartItems.forEach((item, i) => {
      const sku = _ltk.Shopify.GetSkuProperty(item.id, item.sku);
      const { title, quantity, price, image, url: link } = item;
      _ltk.SCA.AddItemWithLinks(sku, quantity, price / 100, title, image, link);

      if (i <= 9) {
        cartLink[item.variant_id] = item.quantity;
      }
    });

    _ltk.SCA.Meta1 = cart.token;
    _ltk.SCA.CartLink = encodeURIComponent(
      JSON.stringify(cartLink).replace(/:/g, "-")
    ).replace(/,/g, "%2C");
    _ltk.SCA.Submit();
  } else {
    _ltk.SCA.ClearCart();
  }
};

const ltkCartUpdate = async () => {
  const url = `${window.location.origin}/cart.js`;
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const cart = await response.json();
    submitCartDataListrak(cart);
  } catch (error) {
    console.error("Error fetching cart data from listrak:", error);
  }
};

const getURLParameter = (param) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
};

const LTKProdBrowse = () => {
  const variants = meta.product.variants;
  setTimeout(() => {
    const idParam = getURLParameter("variant");
    const variant = idParam
      ? variants.find((variant) => variant.id == idParam)
      : variants[0];
    _ltk.Activity.AddProductBrowse(variant.sku);
  }, 1000);
};

const LTKGetCart = () => {
  return setTimeout(() => {
    _ltk.Shopify.GetCartData();
  }, 1000);
};

document.addEventListener("DOMContentLoaded", () => {
  // BROWSE ACTIVITY LISTRAK
  if (window.location.href.includes("/products/")) {
    LTKProdBrowse();
  }
});


class QuickViewDrawerSettings {
  constructor() {
    this.quickViewButtons = document.querySelectorAll(".quick-view");
    this.assignEvents();
  }

  assignEvents() {
    if (this.quickViewButtons.length === 0) return false;

    this.quickViewButtons.forEach((button) => {
      button.addEventListener("click", async () => {
        const handle = button.getAttribute("data-handle");
        const quickViewDrawer = button.parentElement.querySelector("quick-view-drawer");

        if (!quickViewDrawer) return;

        await customElements.whenDefined("quick-view-drawer");

        quickViewDrawer.setAttribute("handle", handle);
        quickViewDrawer.show();
      });
    });
  }
}

class ProductSwatchSettings {
  constructor() {
    this.assignEvents();
  }

  assignEvents() {
    const swatches = document.querySelectorAll(".color-swatch-option a");

    swatches?.forEach((swatch) => {
      swatch.addEventListener("click", (e) => {
        const parent = swatch.closest("safe-sticky");
        if (parent) return;

        e.preventDefault();
        this.handleSwatchChange({
          handle: swatch.getAttribute("data-handle"),
          value: swatch.getAttribute("data-value"),
          event: e,
        });
      });
    });
  }

  async handleSwatchChange({ handle, value, event }) {
    if (!handle) return;

    const responseContent = await (
      await fetch(`${window.Shopify.routes.root}products/${handle}`)
    ).text();

    const optionsData = new DOMParser()
      .parseFromString(responseContent, "text/html")
      .getElementById("options-json-reference").innerHTML;

    const optionsByProduct = JSON.parse(optionsData);
    const currentOption = optionsByProduct.find(
      (option) => option.value == value
    );
    const product = currentOption.product[0];
    const drawer_id = currentOption.drawer_id;

    if (!currentOption) return;
    new SwatchesGrouped({
      id: `card-swatch-${product.id}`,
      product: product,
      event,
      drawer_id,
      value,
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new QuickViewDrawerSettings();
  new ProductSwatchSettings();
});

class assingEventModal {
  constructor(idModal) {
    if (!idModal) return;
    const section = document.getElementById(idModal);

    section.querySelector(".close-button").addEventListener("click", () => {
      section.close();
    });
  }
}

const getSectionByHandleProduct = async ({ handle, dataId }) => {
  if (!handle || !dataId) return;

  const responseContent = await (
    await fetch(`${window.Shopify.routes.root}products/${handle}`)
  ).text();

  const idReference = dataId == "modal-fit" ? "modal-size" : dataId;
  const idModal = dataId == "modal-fit" ? "modal-size-reference" : dataId;

  const sectionReference = new DOMParser()
    .parseFromString(responseContent, "text/html")
    .getElementById(idReference).innerHTML;

  const sectionToReplace = document.getElementById(idModal);

  sectionToReplace.innerHTML = sectionReference;
  sectionToReplace.open();
};

const renderModal = async (event) => {
  const handle = event.target.parentElement.getAttribute("data-handle");
  const dataId = event.target.parentElement.getAttribute("data-section");
  const idModal = dataId == "modal-fit" ? "modal-size-reference" : dataId;

  await getSectionByHandleProduct({
    handle,
    dataId,
  });

  new FitGuideTabs();
  new assingEventModal(idModal);
};
